import { SaveOwner } from "../../Obj2Tab/utils/groupAndAttrSave";
import { TreeNode } from "../model/node";
import { dispatch } from "./registry";
import { KindContext } from "./types";

/**
 * Владелец сохраняемой сущности по узлу её владельца.
 *
 * Отвечает на единственный вопрос, ради которого общий код сохранения раньше
 * требовал всё дерево: куда класть новую сущность — в объект, в группу или
 * в значение справочника.
 */
export const saveOwnerOf = (
  node: Exclude<TreeNode, { kind: "object" }>,
  ctx: KindContext,
): SaveOwner => {
  const owner = ctx.node(node.ownerId);
  if (!owner) throw Error(`Не найден владелец узла ${node.data.name}`);
  return dispatch<SaveOwner>(owner, {
    object: (it) => ({ kind: "object", objectId: it.data.id }),
    group: (it) => ({ kind: "group", groupId: it.data.id }),
    value: (it) => {
      const group = ctx.node(it.ownerId);
      if (group?.kind !== "group") {
        throw Error(`Не найдена группа значения ${it.data.name}`);
      }
      return { kind: "value", groupId: group.data.id, valueId: it.data.id };
    },
    attribute: () => {
      throw Error("Атрибут не может быть владельцем");
    },
  });
};
